export default "__VITE_ASSET__qS2IPpd___"